// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3PnKi","messages":"Chat_messages__3rXlH","dateDivider":"Chat_dateDivider__WX_iY"};